import { getAttributes } from './actions/attributesActions';
import { ATTRIBUTES_ARCHIVE } from './action-types/attributes-types';
import {
  ATTRIBUTE_POST,
  ATTRIBUTE_UPDATE,
} from './action-types/focused-attribute-types';
import { snackbarShowMessage } from '../redux/actions/snackbarActions';

const REFRESH_ACTION_TYPES = [
  ATTRIBUTE_POST.SUCCESS,
  ATTRIBUTE_UPDATE.SUCCESS,
  ATTRIBUTES_ARCHIVE.SUCCESS,
];

const attributesMiddleware = store => {
  const { dispatch, getState } = store;

  return next => action => {
    if (REFRESH_ACTION_TYPES.includes(action.type)) {
      const state = getState();
      const { selectedBrand } = state.UIReducer || {};
      dispatch(getAttributes({ brand: selectedBrand }));
    }

    if (action.type === ATTRIBUTE_POST.SUCCESS) {
      dispatch(snackbarShowMessage('Attribute successfully created'));
    }

    if (
      [ATTRIBUTE_UPDATE.SUCCESS, ATTRIBUTES_ARCHIVE.SUCCESS].includes(
        action.type,
      )
    ) {
      dispatch(snackbarShowMessage('Attribute successfully updated'));
    }

    next(action);
  };
};

export default attributesMiddleware;
